"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const Autocomplete_1 = require("@mui/material/Autocomplete");
const selectors_1 = require("@/store/ducks/countries/selectors");
const index_view_1 = __importDefault(require("./index.view"));
const countries_1 = require("@/store/ducks/countries");
const ports_1 = require("@/store/ducks/ports");
function SearchCountriesAutocomplete() {
    const countriesOptions = (0, react_redux_1.useSelector)(selectors_1.countriesOptionsSelector);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [value, setValue] = react_1.default.useState({
        label: "",
        value: "",
    });
    const [isOpen, setOpen] = react_1.default.useState(false);
    const onOpen = react_1.default.useCallback(() => {
        setOpen(true);
    }, [setOpen]);
    const onClose = react_1.default.useCallback(() => {
        setOpen(true);
    }, [setOpen]);
    const onChange = react_1.default.useCallback((_, value) => {
        setValue(value);
        dispatch((0, countries_1.setCountryId)(value?.value));
        dispatch((0, ports_1.filterPortsByCountry)(value?.value));
    }, []);
    const filterOptions = (0, Autocomplete_1.createFilterOptions)({
        matchFrom: "start",
        stringify: (option) => option.label,
    });
    return (react_1.default.createElement(index_view_1.default, { options: countriesOptions, name: "searchCountries", onChange: onChange, filterOptions: filterOptions, isOpen: isOpen, id: "searchCountries", value: value, onOpen: onOpen, onClose: onClose }));
}
exports.default = SearchCountriesAutocomplete;
